import React, {Component} from "react";
import "./Upload.css"
import Authentication from "../../authentication/Authentication";
import Api from "../../api/Api";
import {toast} from "react-toastify";

export default class DuplicateService extends Component {

    constructor(props) {
        super(props);
        this.state = {
            email: "",
            serviceName: "",
            serviceNameIsValid: true,
            signupError: "",
            showErrorMessage: false,
            showDuplicateButton: false,
            showLoadAfterCreate: false
        };

        this.authentication = new Authentication();
    };

    handleEmailInput(event, event_tag){
        this.setState({
            email: event.target.value
        })
    }

    handleServiceNameInput(event, event_tag){
        const serviceName = event.target.value;

        if (serviceName.match(/^[a-z0-9]{1,22}$/)) {
            this.setState({
                serviceName: event.target.value,
                serviceNameIsValid: true,
                signupError: ""
            })
        }  else {
            this.setState({
                serviceName: event.target.value,
                serviceNameIsValid: false,
                signupError: ""
            })
        }
    }

    isEmpty = (str) => {
        return str.length === 0;
    }

    successCallback = () => {
        this.props.togglePopUp()
    }

    handleDuplicate() {

        this.setState({
            showLoadAfterCreate: true,
        })
        const api = new Api();
        const pisaasPackageId = 7

        api.pisaasDuplicate(() => this.successCallback(), function (err) {
            console.log(err);
            toast.error("Failed to fetch Pisaas Instances", {
                position: toast.POSITION.BOTTOM_RIGHT
            });
        }, this.props.domain, this.state.serviceName, pisaasPackageId, this.state.email, this.props.orginalEmail, this.props.region);
    }

    render() {
        return (
            <>
                <h2 className={"config-header"} data-testid="config.header.duplicate">Duplicate Service</h2>
                <ul>
                    <li>Duplicate service for testing purposes</li>
                    <li>Enter a service name and click duplicate</li>
                    <li>A new pisaas instance will start up with replicated configuration</li>
                    <li>Username and password will be reset to default</li>
                    <li>Duplication may take up to 20 minutes</li>
                    <li>The loading bar may not be accurate during this time and may stay on 0% progress for the first 10 minutes</li>
                </ul>
                <div className={"gap-top-4"}>
                    <span className={"field-name"} data-testid="config.duplicate.email">Email:</span>
                    <input onChange={(event) => this.handleEmailInput(event)} className="domain-input generic-input" type="text" data-testid="config.duplicate.input.email"/>
                </div>
                <div className={"gap-top-4"}>
                    <span className={"field-name"} data-testid="config.duplicate.serviceName">Service Name:</span>
                    <input onChange={(event) => this.handleServiceNameInput(event)} className="domain-input generic-input" type="text" data-testid="config.duplicate.input.serviceName"/>
                    {!this.state.serviceNameIsValid ? <p className={"warning-text"} data-testid="config.duplicate.warning">Service name cannot contain capital letters, special characters, spaces or be blank and more than 22 characters long</p> : <></>}
                    {this.state.showErrorMessage && !this.isEmpty(this.state.serviceName) ? <p className={"warning-text"} data-testid="config.duplicate.warning">There was a problem signing up - please try again with a different service name</p> : <></>}
                </div>
                {this.state.showLoadAfterCreate ? <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading"/> :
                    this.state.serviceNameIsValid && !this.isEmpty(this.state.email) && !this.isEmpty(this.state.serviceName) ? <button className={"try-pi-btn gap-top-4 btn-create"} data-testid="config.duplicate.button.signUp"  onClick={() => {this.handleDuplicate()}}>SIGN UP</button> :
                        <button className={"try-pi-btn gap-top-4 btn-create disabled"} disabled={true} data-testid="config.duplicate.button.signUp">SIGN UP</button>}
            </>
        )
    }
}



